import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getBackgroundChecksRequest } from "../../../services/backgroundChecks/getBackgroundChecksRequest";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const QUERY_BACKGROUND_CHECKS_REQUEST =
  "QUERY_BACKGROUND_CHECKS_REQUEST";

export const useQueryBackgroundChecksRequest = (
  requestId: string,
  queryConfig?: WSQueryConfig<IBackgroundCheckRequestResponse, WSServiceError>
) => {
  return useWSQuery(
    [QUERY_BACKGROUND_CHECKS_REQUEST, requestId],
    () => getBackgroundChecksRequest(requestId),
    queryConfig
  );
};
